// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productTile":"productTile_twgqJ","nonControls":"nonControls_ruFiB"};